import { InjectionToken, Type } from '@angular/core'

import {
  IRoleplayAssessmentDisplay,
  IRoleplaySoundEffect,
} from '../roleplay-assessment.types'

/**
 * 評価表示コンポーネントのアドオントークン。
 * コンポーネント型（Type<IRoleplayAssessmentDisplay>）を提供する。
 * optional inject により、アドオン未登録時は既存動作（評価非表示）を維持する。
 *
 * @deprecated ROLEPLAY_SESSION_ASSESSMENT_DISPLAY または
 * ROLEPLAY_HISTORY_ASSESSMENT_DISPLAY を使用してください。
 */
export const ROLEPLAY_ASSESSMENT_DISPLAY = new InjectionToken<
  Type<IRoleplayAssessmentDisplay>
>('ROLEPLAY_ASSESSMENT_DISPLAY')

/** セッション画面（DIALOGビュー）用の評価表示アドオントークン */
export const ROLEPLAY_SESSION_ASSESSMENT_DISPLAY = new InjectionToken<
  Type<IRoleplayAssessmentDisplay>
>('ROLEPLAY_SESSION_ASSESSMENT_DISPLAY')

/** 対話履歴画面（HISTORYビュー）用の評価表示アドオントークン */
export const ROLEPLAY_HISTORY_ASSESSMENT_DISPLAY = new InjectionToken<
  Type<IRoleplayAssessmentDisplay>
>('ROLEPLAY_HISTORY_ASSESSMENT_DISPLAY')

/**
 * SE再生サービスのアドオントークン。
 * IRoleplaySoundEffect実装インスタンスを提供する。
 * optional inject により、アドオン未登録時は既存動作（SE非再生）を維持する。
 */
export const ROLEPLAY_SOUND_EFFECT = new InjectionToken<IRoleplaySoundEffect>(
  'ROLEPLAY_SOUND_EFFECT',
)
